// ** React Imports
import { lazy } from 'react';

const Achievements = lazy(() => import('../../views/achievements'));

const AchievementsRoutes = [
  {
    element: <Achievements />,
    path: '/my-achievements'
  }
];

export default AchievementsRoutes;
